// Hardcoded because the countries API requires authentication.
// Source: transparency-frontend/utils/oecdCountries.js
export const oecdCountries: { label: string; value: string }[] = [
  { label: 'Argentina', value: 'ARG' },
  { label: 'Australia', value: 'AUS' },
  { label: 'Austria', value: 'AUT' },
  { label: 'Belgium', value: 'BEL' },
  { label: 'Brazil', value: 'BRA' },
  { label: 'Canada', value: 'CAN' },
  { label: 'Chile', value: 'CHL' },
  { label: 'Colombia', value: 'COL' },
  { label: 'Costa Rica', value: 'CRI' },
  { label: 'Czechia', value: 'CZE' },
  { label: 'Denmark', value: 'DNK' },
  { label: 'Egypt', value: 'EGY' },
  { label: 'Estonia', value: 'EST' },
  { label: 'Finland', value: 'FIN' },
  { label: 'France', value: 'FRA' },
  { label: 'Germany', value: 'DEU' },
  { label: 'Greece', value: 'GRC' },
  { label: 'Hungary', value: 'HUN' },
  { label: 'Iceland', value: 'ISL' },
  { label: 'India', value: 'IND' },
  { label: 'Ireland', value: 'IRL' },
  { label: 'Israel', value: 'ISR' },
  { label: 'Italy', value: 'ITA' },
  { label: 'Japan', value: 'JPN' },
  { label: 'Korea', value: 'KOR' },
  { label: 'Latvia', value: 'LVA' },
  { label: 'Lithuania', value: 'LTU' },
  { label: 'Luxembourg', value: 'LUX' },
  { label: 'Malta', value: 'MLT' },
  { label: 'Mexico', value: 'MEX' },
  { label: 'Netherlands', value: 'NLD' },
  { label: 'New Zealand', value: 'NZL' },
  { label: 'Norway', value: 'NOR' },
  { label: 'Peru', value: 'PER' },
  { label: 'Poland', value: 'POL' },
  { label: 'Portugal', value: 'PRT' },
  { label: 'Türkiye', value: 'TUR' },
  { label: 'Romania', value: 'ROU' },
  { label: 'Kingdom of Saudi Arabia', value: 'SAU' },
  { label: 'Senegal', value: 'SEN' },
  { label: 'Serbia', value: 'SRB' },
  { label: 'Singapore', value: 'SGP' },
  { label: 'Slovakia', value: 'SVK' },
  { label: 'Slovenia', value: 'SVN' },
  { label: 'Spain', value: 'ESP' },
  { label: 'Sweden', value: 'SWE' },
  { label: 'Switzerland', value: 'CHE' },
  { label: 'Ukraine', value: 'UKR' },
  { label: 'United Kingdom', value: 'GBR' },
  { label: 'United States', value: 'USA' },
  { label: 'Uruguay', value: 'URY' }
]
